<div class="order-discount-banner">
  <div class="order-discount-banner__container" (click)="claimDiscount()">
    <div class="order-discount-banner__title">
      Win 1000s of prizes INSTANTLY
    </div>
    <div class="order-discount-banner__badge">Claim 10% Discount</div>
  </div>
  <svg-icon
    class="order-discount-banner__icon"
    name="cross"
    (click)="closeBanner()"
  ></svg-icon>
</div>
